/* ============================================================
   Mehlography Lab - Product card image slider（LV 流）
   - PC: ホバーで2枚目へ切替＋矢印はホバー時のみ。離脱で1枚目へ戻る
   - スマホ: スワイプで送り、下部の進捗バーで現在位置を示す（矢印なし）
   - タップ: 商品ページへ遷移（data-url）
   - イベント委譲: カード数に依らずリスナーは固定数（document に数個）
   - 遅延 hydrate: 2枚目以降は初回操作時に data-src/data-srcset を実体化
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '[data-mhl-card-slider]';
  var SWIPE_THRESHOLD = 40; // px
  var swipeGuardUntil = 0; // この時刻まではカード内クリックを遷移させない

  // JS 起動の合図。CSS はこのクラスが付くまで矢印/ドットを隠す（JS 失敗時は1枚目のみ表示）
  document.documentElement.classList.add('mhl-card-slider-on');

  function hydrate(slider) {
    if (slider.dataset.hydrated === '1') return;
    slider.dataset.hydrated = '1';
    var imgs = slider.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.srcset) img.srcset = img.dataset.srcset.trim();
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
  }

  function wrap(idx, count) {
    // 無限ループ: 端を越えたら反対側へ回る
    return ((idx % count) + count) % count;
  }

  function goTo(slider, idx) {
    var count = parseInt(slider.dataset.count, 10) || 1;
    idx = wrap(idx, count);
    hydrate(slider);

    var track = slider.querySelector('[data-mhl-card-slider-track]');
    if (track) track.style.transform = 'translateX(' + -idx * 100 + '%)';
    slider.dataset.current = idx;

    // 進捗バー（スマホ表示）: つまみ幅 = 1/枚数、位置 = 現在スライド
    var bar = slider.querySelector('[data-mhl-card-slider-bar]');
    if (bar) {
      bar.style.width = 100 / count + '%';
      bar.style.transform = 'translateX(' + idx * 100 + '%)';
    }
  }

  function current(slider) {
    return parseInt(slider.dataset.current, 10) || 0;
  }

  /* ---- クリック（矢印） ---- */
  document.addEventListener('click', function (e) {
    // スワイプ直後の合成クリックはカードリンクごと抑止
    if (Date.now() < swipeGuardUntil) {
      var swiped = e.target.closest(SELECTOR);
      if (swiped) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
    }

    var prev = e.target.closest('[data-mhl-card-slider-prev]');
    var next = e.target.closest('[data-mhl-card-slider-next]');

    if (prev || next) {
      var slider = e.target.closest(SELECTOR);
      if (!slider) return;
      e.preventDefault();
      e.stopPropagation();
      if (prev) goTo(slider, current(slider) - 1);
      else goTo(slider, current(slider) + 1);
      return;
    }

    // 矢印以外のタップ: data-url を持つ（card-product 等、カードリンクが
    // スライダーに覆われ届かないケース）なら商品ページへ遷移させる。
    // data-url が無いカード（外側が <a> の mehlography-card）は何もせず既存リンクに委ねる。
    var navSlider = e.target.closest(SELECTOR);
    if (navSlider && navSlider.dataset.url) {
      window.location.href = navSlider.dataset.url;
    }
  });

  /* ---- タッチスワイプ ---- */
  var startX = 0;
  var startY = 0;
  var activeSlider = null;
  var swiping = false;

  document.addEventListener(
    'touchstart',
    function (e) {
      var slider = e.target.closest(SELECTOR);
      if (!slider) return;
      activeSlider = slider;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiping = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!activeSlider) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) swiping = true;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!activeSlider) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (swiping && Math.abs(dx) > SWIPE_THRESHOLD) {
        goTo(activeSlider, current(activeSlider) + (dx < 0 ? 1 : -1));
        swipeGuardUntil = Date.now() + 350; // 直後の合成クリックを無効化
      }
      activeSlider = null;
      swiping = false;
    },
    { passive: true }
  );

  /* ---- ホバーで2枚目に切替（PC のみ。タッチ端末では発火させない） ---- */
  var hoverCapable = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  if (hoverCapable) {
    document.addEventListener('mouseover', function (e) {
      var slider = e.target.closest(SELECTOR);
      if (!slider || slider.dataset.hovered === '1') return;
      slider.dataset.hovered = '1';
      if ((parseInt(slider.dataset.count, 10) || 1) > 1) goTo(slider, 1);
    });
    document.addEventListener('mouseout', function (e) {
      var slider = e.target.closest(SELECTOR);
      if (!slider) return;
      // 移動先がまだ同じスライダー内なら離脱ではない
      if (e.relatedTarget && slider.contains(e.relatedTarget)) return;
      slider.dataset.hovered = '';
      goTo(slider, 0);
    });
  }
})();
